var _style, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursorCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cursor_caret_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 864 269",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cursor_caret_svg__st1{fill:#f8edd4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.1 3.9h588.7c73.5 0 133.1 58.2 133.1 130s-59.6 130-133.1 130H137.1C63.6 263.9 4 205.7 4 133.9s59.6-130 133.1-130z",
    fill: "#f9af05"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cursor_caret_svg__st1",
    cx: 159.9,
    cy: 136.3,
    r: 81.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cursor_caret_svg__st1",
    cx: 430,
    cy: 136.3,
    r: 81.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cursor_caret_svg__st1",
    cx: 700,
    cy: 136.3,
    r: 81.3
  })));
}
export default SvgCursorCaret;